<script>
import baseMixin from '@/mixins/baseMixin'
import config from '@/common/config'

export default {
  name: 'ThePasswordRulesIndicator',
  mixins: [baseMixin],
  props: {
    password: {
      type: String,
      default: '',
    },
    cols: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      rules: [
        {
          title: this.$t('password.ruleIndicatorLowerCaseLabel'),
          id: 'password-rules-lowercase',
          rule: (v) => !!v && v.toUpperCase() !== v,
        },
        {
          title: this.$t('password.ruleIndicatorUpperCaseLabel'),
          id: 'password-rules-uppercase',
          rule: (v) => !!v && v.toLowerCase() !== v,
        },
        {
          title: this.$t('password.ruleIndicatorNumberLabel'),
          id: 'password-rules-number',
          rule: (v) => !!v && /\d/.test(v),
        },
        {
          title: this.$t('password.ruleIndicatorSpecialCharacterLabel'),
          id: 'password-rules-special',
          rule: (v) => !!v && config.get('password.allowedCharsRegex').test(v),
        },
        {
          title: this.$t('password.ruleIndicatorMinCharactersLabel', {
            min: config.get('password.minChars'),
          }),
          id: 'password-rules-char-count',
          rule: (v) => !!v && v.length >= config.get('password.minChars'),
        },
      ],
    }
  },
  computed: {
    passwordCriteriaMet() {
      return (
        !!this.password &&
        this.password.toUpperCase() !== this.password &&
        this.password.toLowerCase() !== this.password &&
        /\d/.test(this.password) &&
        config.get('password.allowedCharsRegex').test(this.password) &&
        this.password.length >= config.get('password.minChars')
      )
    },
    columns() {
      const columns = []
      const mid = Math.ceil(
        Object.keys(this.rules).length /
          (!this.isMobileViewPort ? this.cols : 1)
      )
      for (let col = 0; col < (!this.isMobileViewPort ? this.cols : 1); col++) {
        columns.push(
          Object.entries(this.rules)
            .slice(col * mid, col * mid + mid)
            .map((entry) => entry[1])
        )
      }
      return columns
    },
  },
}
</script>

<template>
  <div id="password-rules-container">
    <!-- Password criteria list -->
    <div v-if="!passwordCriteriaMet" id="password-rules-list" class="d-flex">
      <div
        v-for="(col, colIndex) in columns"
        :key="colIndex"
        class="d-inline-block mr-12"
      >
        <div v-for="rule in col" :id="rule.id" :key="rule.id" class="mb-1">
          <v-icon
            left
            x-small
            :color="rule.rule(password) ? '' : 'blue'"
            :data-rule-met="rule.rule(password) ? 'true' : 'false'"
          >
            mdi-circle
          </v-icon>
          <span
            :class="
              (rule.rule(password)
                ? ''
                : isDarkMode
                ? 'white--text'
                : 'black--text',
              'password-rules_text')
            "
          >
            {{ rule.title }}
          </span>
        </div>
      </div>
    </div>

    <!-- Password criteria met alert -->
    <v-alert
      v-else
      id="password-rules_sucess-alert"
      type="success"
      class="rounded-lg"
      text
    >
      <span class="body-2"> {{ $t('password.rulesMetSuccessText') }} </span>
    </v-alert>
  </div>
</template>
